/* Libs */
import create from 'zustand';

/* Model */
import Furnitures from 'Models/Furnitures';

const [useFurnituresStore] = create((set, get) => ({
	furnitures: null,
	currentFurnitures: null,
	fetchingFurnitures: false,
	fetchFurnitures: async () => {
		set({ fetchingFurnitures: true });
		const response = await Furnitures.get();
		console.log('set furnitures', response);
		set({ furnitures: response, fetchingFurnitures: false });

		return response;
	},
	getCurrentFurnitures: (categoryid) => {
		const { furnitures } = get();
		const currentFurnitures = furnitures.filter(furniture => furniture.category && furniture.category.id === categoryid);

		console.log('set current furnitures', currentFurnitures);
		set({ currentFurnitures });

		return currentFurnitures;
	},
	createFurniture: async (params) => {
		const { furnitures } = get();
		const response = await Furnitures.create(params);
		console.log('new furniture', response);
		if (!response.error) {
			set({ furnitures: [...furnitures, response] });
		}
		return response;
	}
}));

export default useFurnituresStore;
